import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=195399cf&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=js&"
export * from "./newIndex.vue?vue&type=script&lang=js&"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=195399cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195399cf",
  null
  
)

export default component.exports